import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RegionDistrictService } from '../service/region-district.service';
import { AppMessageService } from '../../../../shared/services/app-message/app-message.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'region-district-description-modal',
  templateUrl: './region-district-desription-modal.html',
  styleUrls: ['./region-district-desription-modal.scss'],
})
export class RegionDistrictDescriptionComponent {
  @Input() district: any;
  @Output() submitOn: EventEmitter<any> = new EventEmitter();

  visible = false;
  @Input() modal: boolean = true;
  @Output() closeOn = new EventEmitter();
  @Input() form: FormGroup;
  isSubmit: boolean = false;

  autocompleteInput: string;
  queryWait: boolean;
  selectedValue: any = {
    selectedRegion: null,
    district: null,
  };
  title: string = '';

  constructor(
    private readonly fb: FormBuilder,
    private readonly regionDistrictService: RegionDistrictService,
    private readonly messageService: AppMessageService,
    private readonly translate: TranslateService
  ) {
    this.form = this.fb.group({
      description: ['', Validators.required],
    });
  }

 

 

  onSave() {
    this.isSubmit = true;

    // Mark all controls as touched to show validation errors
    this.form.markAllAsTouched();

    if (this.form.invalid) return;
    const data = {
      regionDistrictId: this.selectedValue?.district?.id,
      description: this.form?.value?.description,
      region_number:this.selectedValue?.district?.region_number
    };
    this.regionDistrictService.updateRegionDistrict(data).subscribe((res) => {

      if (res) {
        this.messageService.successToast(
          this.translate.instant('common.success'),
          this.translate.instant('common.updateSuccessToastMessage'),
          70000
        );
        this.submitOn.emit(res);
        this.visible = false;
        this.form.reset();
      }
    });
  }

  openDialog(selectedRegion: any, district: any) {
    this.selectedValue.selectedRegion = selectedRegion;
    this.selectedValue.district = district;
    this.title =
      selectedRegion?.main_district?.name + ' - ' + district?.district?.name;
    this.form.patchValue({ description: district?.description });
    this.visible = true;
  }

  closeDialog() {
    this.visible = false;
    this.closeOn.emit();
    this.resetForm(); // Call the reset function
  }

  resetForm() {
    this.form.reset();
  }
}
